export default "/images/vendor/flag-icon-css/flags/4x3/np.svg?ecc31e52fb6b958eb68131f217009d1b";